<div class="main-container">
  <div class="grid-container" id="nareport-grid-container" style="height:calc(100% - 55px);">
    <div class="top-toolbar">
      <div class="float-left ml-2">
        @if (taxyearLoaded) {
          <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'"
            [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem"
            (onSelect)="onTaxYearChanged($event)">
            @for (item of taxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)"
                (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }
        <gtw-df-me-dropdown class="top-filter-select me-dropdown-label mr-2" [customActionCode]="32136"
          (selectedMes)="selectedMeChanged($event)"></gtw-df-me-dropdown>
        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" class="ap-mr-spacing-3"
          (onClick)="refresh()"></ap-button>
        <button class="export-btn" (click)="exportToExcel()">
          <i class="Appkit4-icon icon-save-outline"></i>
          Export to Excel
        </button>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort class="dst-mat-table">
          <ng-container matColumnDef="TAXYEAR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
              {{ getColByField('TAXYEAR').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
              <span>{{ rowData.TAXYEAR }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('STATEMENTID'))">
              {{ getColByField('STATEMENTID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" style="overflow: visible;"
              [ngStyle]="getDstColStyle(getColByField('STATEMENTID'))">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('STATEMENTNAME'))">
              {{ getColByField('STATEMENTNAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('STATEMENTNAME'))">
              <span>{{ rowData.STATEMENTNAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYBUSINESS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYBUSINESS'))">
              {{ getColByField('PRIMARYBUSINESS').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYBUSINESS'))">
              <span>{{ rowData.PRIMARYBUSINESS }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYLEID'))">
              {{ getColByField('PRIMARYLEID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYLEID'))">
              <span>{{ rowData.PRIMARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYENTITY'))">
              {{ getColByField('PRIMARYENTITY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYENTITY'))">
              <span>{{ rowData.PRIMARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYBUSINESS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('SECONDARYBUSINESS'))">
              {{ getColByField('SECONDARYBUSINESS').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('SECONDARYBUSINESS'))">
              <span>{{ rowData.SECONDARYBUSINESS }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('SECONDARYLEID'))">
              {{ getColByField('SECONDARYLEID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('SECONDARYLEID'))">
              <span>{{ rowData.SECONDARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('SECONDARYENTITY'))">
              {{ getColByField('SECONDARYENTITY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('SECONDARYENTITY'))">
              <span>{{ rowData.SECONDARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ISQARSTR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('ISQARSTR'))">
              {{ getColByField('ISQARSTR').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('ISQARSTR'))">
              <span>{{ rowData.ISQARSTR }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="MODIFIEDBY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDBY'))">
              {{ getColByField('MODIFIEDBY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDBY'))">
              <span>{{ rowData.MODIFIEDBY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="MODIFIEDON">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDON'))">
              {{ getColByField('MODIFIEDON').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDON'))">
              <span>{{ rowData.MODIFIEDON | date:'yyyy/MM/dd' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="CREATEDBY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('CREATEDBY'))">
              {{ getColByField('CREATEDBY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('CREATEDBY'))">
              <span>{{ rowData.CREATEDBY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="CREATEDON">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('CREATEDON'))">
              {{ getColByField('CREATEDON').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('CREATEDON'))">
              <span>{{ rowData.CREATEDON | date:'yyyy/MM/dd' }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>

  @if (showModalViewer) {
    <dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
    </dst-disc-modal-viewer>
  }
</div>
